import React, { useState } from 'react';
import { TestimonialLayout } from './testimonials/TestimonialLayout';
import { TestimonialHeader } from './testimonials/TestimonialHeader';
import { TestimonialMetric } from './testimonials/TestimonialMetric';
import { TestimonialQuote } from './testimonials/TestimonialQuote';
import { Book, Target, Brain } from 'lucide-react';
import { VideoModal } from '../common/VideoModal';
import { IMAGE_PATHS } from '@/utils/images';

const metrics = [
  {
    icon: Book,
    label: "Learning Goals",
    value: "90%",
    detail: "9 of 10 milestones reached",
    color: "text-neon-green"
  },
  {
    icon: Target,
    label: "Home Purchase",
    value: "35%",
    detail: "7 of 20 milestones reached",
    color: "text-neon-purple"
  },
  {
    icon: Brain,
    label: "Retirement",
    value: "25%",
    detail: "5 of 20 milestones reached",
    color: "text-yellow-400"
  }
];

export const SarahTestimonial: React.FC = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <TestimonialLayout>
      <div className="relative">
        <div className="relative h-[80vh] overflow-hidden">
          <div className="absolute inset-0">
            <img 
              src={IMAGE_PATHS.SARAH_AVATAR}
              alt="Sarah"
              className="w-full h-full object-cover object-top"
              onError={(e) => {
                const img = e.target as HTMLImageElement;
                img.onerror = null;
                img.src = IMAGE_PATHS.FALLBACK;
              }}
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black" />
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-12">
          <div className="max-w-7xl mx-auto">
            <div className="space-y-6 max-w-2xl">
              <TestimonialHeader 
                title="Meet Sarah: A LifeTrack Success Story 🚀"
                subtitle="At 28, Sarah has transformed her approach to personal development using LifeTrack."
              />

              <div className="grid grid-cols-3 gap-4">
                {metrics.map((metric) => (
                  <TestimonialMetric key={metric.label} {...metric} />
                ))}
              </div>

              <TestimonialQuote 
                quote="LifeTrack has completely changed how I approach my goals. The gamification makes building healthy habits and planning for the future actually enjoyable!"
                author="Sarah"
              />
            </div>
          </div>
        </div>
      </div>

      <VideoModal
        isOpen={showVideo}
        onClose={() => setShowVideo(false)}
        videoUrl={IMAGE_PATHS.DEFAULT_VIDEO}
      />
    </TestimonialLayout>
  );
};